import React from "react";

/**
 * The wide hand-drawn rule under the hero's second headline line. Distinct from
 * the InstantCash squiggle: a longer, shallower wave on a 300-unit viewBox with
 * preserveAspectRatio="none" so it stretches to the full width of the phrase.
 * Path, viewBox and stroke taken verbatim from the reference.
 */
const Underline = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 300 20"
    preserveAspectRatio="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M2 12 Q 40 2, 80 12 T 160 12 T 240 12 T 298 12"
      fill="none"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

export default Underline;
